import { render, staticRenderFns } from "./BankConfigureCtepTerminal.vue?vue&type=template&id=2a381fcc"
import script from "./BankConfigureCtepTerminal.vue?vue&type=script&lang=ts"
export * from "./BankConfigureCtepTerminal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a381fcc')) {
      api.createRecord('2a381fcc', component.options)
    } else {
      api.reload('2a381fcc', component.options)
    }
    module.hot.accept("./BankConfigureCtepTerminal.vue?vue&type=template&id=2a381fcc", function () {
      api.rerender('2a381fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/BankConfigureCtepTerminal.vue"
export default component.exports